// import useCustomRouter from "../../../services/utilities/customRouter";


// import { Typography, Button, TextField } from "@mui/material";
// import { useState } from "react";
// import { useRequestResetPasswordMutation } from "../../../services/apis/auth";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import { Formik, Form, Field, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import { hybridDecrypt, hybridEncrypt } from "./encryption";

// function Forgot() {
//   const [requestResetPassword] = useRequestResetPasswordMutation();
//   const navigate = useNavigate();

//   const initialValues = {
//     email: "",
//   };

//   const validationSchema = Yup.object().shape({
//     email: Yup.string()
//       .email("Please enter a valid email address")
//       .required("Email is required"),
//   });

//   const handleSubmit = async (values, { setSubmitting }) => {
//     try {
//       const encryptedPayload = await hybridEncrypt({ email: values.email });

//       // const result = await requestResetPassword({ encryptedData: encryptedPayload });
//       const result = await requestResetPassword({ email: values.email });

//       if (!result?.data?.encryptedData) {
//         if (result?.data?.success === false) {
//           toast(result.error.data.message);
//         } else {
//           toast.error(result.error.data.message);
//         }
//       } else {
//         const decryptedPayload = await hybridDecrypt(result?.data?.encryptedData);

//         if (decryptedPayload?.success === true) {
//           toast(decryptedPayload.message);
//         } else {
//           toast.error(result.error.data.error.message);
//         }
//       }

//     } catch (error) {
//       // Handle error
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <>
//       <div className="flex items-center justify-center h-full">
//         <div className="text-primary w-3/5 flex flex-col gap-2">
//           <div className="mb-7">
//             <Typography variant="h3">
//               Lost your password? Enter your details to recover.
//             </Typography>
//             <small className="text-secondary ms-1">
//               {" "}
//               Enter your details to proceed further
//             </small>
//           </div>

//           <Formik
//             initialValues={initialValues}
//             validationSchema={validationSchema}
//             onSubmit={handleSubmit}
//           >
//             {({ isSubmitting, errors, touched }) => (
//               <Form>
//                 <label htmlFor="email" className="text-md ms-1">
//                   Email Id{" "}
//                 </label>

//                 <Field
//                   as={TextField}
//                   margin="dense"
//                   type="email"
//                   fullWidth
//                   name="email"
//                   id="email"
//                   placeholder="Enter here"
//                   error={!!errors.email && touched.email}
//                   helperText={<ErrorMessage name="email" />}
//                 />

//                 <Button
//                   type="submit"
//                   variant="contained"
//                   disabled={isSubmitting}
//                   sx={{
//                     backgroundColor: "var(--primary)",
//                     width: 178,
//                     height: 46,
//                     fontFamily: "var(--font-inter)",
//                     fontSize: 15,
//                     borderRadius: 2,
//                     textTransform: "none",
//                     my: 3,
//                     ":hover": {
//                       backgroundColor: "var(--primary)",
//                     },
//                   }}
//                 >
//                   Recover
//                 </Button>
//               </Form>
//             )}
//           </Formik>
//         </div>

//       </div>
//       <PasswordReset />
//     </>
//   );
// }

// export default Forgot;




// function PasswordReset({ mailId }) {
//   const { navigate } = useCustomRouter();
//   return (
//     <div className="flex items-center justify-center  h-full ">
//       <div className="text-primary w-2/3  flex flex-col gap-2">
//         <div className="p-3">
//           <Typography variant="h3">Password Reset Mail Sent</Typography>
//           <br />
//           <small className="text-secondary mt-2 ">
//             {" "}
//             An e-mail has been sent to your rescue email address,
//             J******123@mail.com, follow the directions in your e-mail to reset
//             your password.
//           </small>
//         </div>

//         <Button
//           variant="contained"
//           onClick={() => navigate("/auth/signin")}
//           sx={{
//             backgroundColor: "var(--primary)",
//             width: 178,
//             height: 46,
//             fontFamily: "var(--font-inter)",
//             fontSize: 15,
//             borderRadius: 2,
//             textTransform: "none",
//             ml: 1,
//             ":hover": {
//               backgroundColor: "var(--primary)",
//             },
//           }}
//         >
//           Done
//         </Button>
//       </div>
//     </div>
//   );
// }


import useCustomRouter from "../../../services/utilities/customRouter";
import { Typography, Button, TextField } from "@mui/material";
import { useState } from "react";
import { useRequestResetPasswordMutation } from "../../../services/apis/auth";
import { toast } from "react-toastify";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { hybridDecrypt, hybridEncrypt } from "./encryption";

function Forgot() {
  const [requestResetPassword] = useRequestResetPasswordMutation();

  const [mailSent, setMailSent] = useState(false);
  const [email, setEmail] = useState("");

  const initialValues = {
    email: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setEmail(values.email);

      // If encryption is needed
      // const encryptedPayload = await hybridEncrypt({ email: values.email });
      const payload = { email: values.email };
      const result = await requestResetPassword(payload);
      

      if (result?.data?.success) {
        toast.success(result.data.message || "Password reset mail sent");
        setMailSent(true); // 👈 SHOW SUCCESS PAGE
      } else {
        toast.error(result?.error?.data?.message || "Something went wrong");
      }
    } catch (error) {
      toast.error("Server error");
    } finally {
      setSubmitting(false);
    }
  };

  // ✅ Show success page after mail sent
  if (mailSent) {
    return <PasswordReset mailId={email} />;
  }

  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-primary w-3/5 flex flex-col gap-2">
        <div className="mb-7">
          <Typography variant="h3">
            Lost your password? Enter your details to recover.
          </Typography>
          <small className="text-secondary ms-1">
            Enter your details to proceed further
          </small>
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, errors, touched }) => (
            <Form>
              <label htmlFor="email" className="text-md ms-1">
                Email Id
              </label>

              <Field
                as={TextField}
                margin="dense"
                type="email"
                fullWidth
                name="email"
                placeholder="Enter here"
                error={!!errors.email && touched.email}
                helperText={<ErrorMessage name="email" />}
              />

              <Button
                type="submit"
                variant="contained"
                disabled={isSubmitting}
                sx={{
                  backgroundColor: "var(--primary)",
                  width: 178,
                  height: 46,
                  borderRadius: 2,
                  textTransform: "none",
                  my: 3,
                }}
              >
                Recover
              </Button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default Forgot;

export function PasswordReset({ mailId }) {
  const { navigate } = useCustomRouter();

  const maskedEmail = mailId
    ? mailId.replace(/(.{2}).+(@.+)/, "$1******$2")
    : "";

  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-primary w-2/3 flex flex-col gap-4">
        <Typography variant="h3">Password Reset Mail Sent</Typography>

        <small className="text-secondary">
          An e-mail has been sent to your registered email address,
          <strong> {maskedEmail}</strong>.  
          Follow the instructions in the email to reset your password.
        </small>

        <Button
          variant="contained"
          onClick={() => navigate("/auth/signin")}
          sx={{
            backgroundColor: "var(--primary)",
            width: 178,
            height: 46,
            borderRadius: 2,
            textTransform: "none",
          }}
        >
          Done
        </Button>
      </div>
    </div>
  );
}
